import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import type { MultiLang } from '../../../../config';
import Functions from '../../../../functions';
import ItemUtil, { type ItemBasicFile } from '../../../lib/ItemUtil';
import styles from './Preview.module.css';

interface Props {
    lang: MultiLang;
    file: ItemBasicFile[];
}

const Preview = (props: Props) => {
    const { lang, file } = props;
    const [imageIndex, setImageIndex] = useState(-1);
    const data = file.filter((value) => value.file_type_name === 'preview');
    if (data.length === 0) {
        return null;
    }
    const slides = data.map((value) => ({
        src: ItemUtil.getFileUrl(value),
        alt: Functions.mlang(value.caption, lang),
        title: Functions.mlang(value.caption, lang),
    }));
    return (
        <>
            <div className={styles.previewBox}>
                {data.map((value, idx) => {
                    const caption = Functions.mlang(value.caption, lang);
                    return (
                        <figure key={value.file_id} className={styles.preview}>
                            <a
                                href={ItemUtil.getFileUrl(value)}
                                download={value.original_file_name}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setImageIndex(idx);
                                }}
                            >
                                <img src={ItemUtil.getPreviewFileUrl(value)} alt={caption} />
                            </a>
                            <figcaption>{caption}</figcaption>
                        </figure>
                    );
                })}
            </div>
            <Lightbox
                open={imageIndex >= 0}
                index={imageIndex < 0 ? 0 : imageIndex}
                close={() => setImageIndex(-1)}
                slides={slides}
            />
        </>
    );
};

export default Preview;
